export const markAnswered = (pollId: number) => {
    localStorage.setItem(`poll_${pollId}_a`, 'true');
    localStorage.setItem(`poll_${pollId}_d`, `${new Date()}`);
}

export const wasAnswered = (pollId: number) => {
    return localStorage.getItem(`poll_${pollId}_a`) === 'true';
}